import { EnlargeCollapse } from './EnlargeCollapse.js';
import { Flash } from './Flash.js';
import { Lock } from './Lock.js';
import { Menu } from './Menu.js';
import { More } from './More.js';
import { ToggleLeftSection } from './ToggleLeftSection.js';
import { ToggleList } from './ToggleList.js';
import { ToggleRightSection } from './ToggleRightSection.js';
export const DefaultIcons = {
    EnlargeCollapse,
    Flash,
    Lock,
    Menu,
    More,
    ToggleLeftSection,
    ToggleList,
    ToggleRightSection,
};
export default DefaultIcons;
